export enum SIGNUP_ROUTES {
  ACCOUNT = '/apply/account',
  PERSONALIZE = '/apply/personalize',
  ADDRESS = '/apply/address',
  BILLING = '/apply/billing',
  REVIEW = '/apply/review',
  SUCCESS = '/apply/success'
}

export enum AMBASSADOR_SIGNUP_ROUTES {
  APPLY = '/apply/ambassador',
  SUCCESS = '/apply/ambassador/success'
}

/** Promo codes with this prefix are reserved for the Brand Ambassador application flow (case-insensitive) */
export const BRAND_AMBASSADOR_CODE_PREFIX = 'influencer';

/** Error code for a promo code that is disabled or at its redemption limit at submit time. */
export const PROMO_CODE_UNAVAILABLE = 'promo_code_unavailable';

export const PROMO_CODE_UNAVAILABLE_MESSAGE =
  'This code has already been redeemed.';
